"use client";
import { createContext, useContext } from "react";
import { BlogPageProps } from "@/types/strapi/blogPage";
import { BlogSearchArticlesFn } from "@/helpers/blog/useBlogSearch";
import { ArticleListItemData } from "@/types/strapi/article";
import { BlogPaginationProps } from "@/components/pages/blog/BlogPagination";

export type BlogPageContextType =
  | (BlogPageProps & {
      notFound: boolean;
      articles: ArticleListItemData[];
      clientPagination: BlogPaginationProps;
    })
  | null;

export const BlogPageContext = createContext<BlogPageContextType>(null);

export const useBlogPageContext = () => useContext(BlogPageContext);
